module.exports = __webpack_public_path__ + "img/counters-for-the-poor-blue.cb108eb6.png";